import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";

export const NavBar = ({ activeStep, setActiveStep }) => {
  return (
    <Swiper slidesPerView={"auto"} className="configurator-nav poppins-20-600">
      <>
        <SwiperSlide className="configurator-nav__slide">
          <p
            onClick={() => {
              if (activeStep > 0) {
                setActiveStep(0);
              }
            }}
            className={`configurator-nav__item | js-conf-nav-item ${
              activeStep == 0 ? "active" : ""
            }`}
          >
            1. Izbor predmeta
          </p>
        </SwiperSlide>
        <SwiperSlide className="configurator-nav__slide">
          <p
            onClick={() => {
              if (activeStep > 1) {
                setActiveStep(1);
              }
            }}
            className={`configurator-nav__item | js-conf-nav-item ${
              activeStep == 1 ? "active" : ""
            }`}
          >
            2. Dimenzije
          </p>
        </SwiperSlide>

        <SwiperSlide className="configurator-nav__slide">
          <p
            onClick={() => {
              if (activeStep > 2) {
                setActiveStep(2);
              }
            }}
            className={`configurator-nav__item | js-conf-nav-item ${
              activeStep == 2 ? "active" : ""
            }`}
          >
            3. Stil i opcije
          </p>
        </SwiperSlide>

        <SwiperSlide className="configurator-nav__slide">
          <p
            className={`configurator-nav__item | js-conf-nav-item ${
              activeStep == 3 ? "active" : ""
            }`}
          >
            4. Upit
          </p>
        </SwiperSlide>
      </>
    </Swiper>
  );
};
